import { Container } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

interface AssessmentStepSkeletonProps {
    dataTestId: string;
}

/** What a manager-assessment step shows under its header while the cycle instance is on its way. */
export const AssessmentStepSkeleton = ({ dataTestId }: AssessmentStepSkeletonProps) => (
    <Container
        direction={'col'}
        py={'md'}
        className={'assessment-journey w-full'}
        dataTestId={dataTestId}
    >
        <Skeleton>
            <div className={'space-y-6'}>
                <Bone className={'h-7.5 w-50'} />

                <Bone className={'h-30 w-full'} />

                <Bone className={'h-60 w-full'} />
            </div>
        </Skeleton>
    </Container>
);
